var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('l-layer-group',[_c('l-wms-tile-layer',{attrs:{"base-url":_vm.layer.url,"layers":_vm.layer.layer,"crs":_vm.layer.crs,"atribution":"IVisio 2020"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }